import { render, staticRenderFns } from "./PrematchDetailView.vue?vue&type=template&id=0b7a0f51"
import script from "./PrematchDetailView.vue?vue&type=script&lang=js"
export * from "./PrematchDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports